import { Injectable } from '@angular/core';
import { ConfigurationService } from 'app/_shared/services';
import { BehaviorSubject, lastValueFrom } from 'rxjs';
import { ListRequest } from '../../_shared/models/list-request.model';
import { Disposition } from './disposition.model';
import { HttpClient } from '@angular/common/http';
import { ListResponse } from 'app/_shared/models/list-response.model';
import { Result } from 'app/_shared/models/api.model';

@Injectable({
  providedIn: 'root'
})
export class DispositionsService {
  serviceUri: string;
  dispositions: BehaviorSubject<ListResponse<Disposition>> = new BehaviorSubject<ListResponse<Disposition>>({records: []} as ListResponse<Disposition>);
  constructor(
    private http: HttpClient,
    private config: ConfigurationService) { 
    this.config.Config.subscribe((config) => {
      this.serviceUri = `${config.apiUri}/dispositions/`;
    });
  }

  async getDispositions(request: ListRequest, force: boolean = false): Promise<ListResponse<Disposition>> {
    console.debug('Getting dispositions');
    if (!force && this.dispositions.value.records.length > 0) {
      console.debug('Dispositions already loaded');
      return this.dispositions.value;
    }
    
    var result = await lastValueFrom(this.http.post<Result<ListResponse<Disposition>>>(this.serviceUri, request));
    this.dispositions.next(result.data);
    return result.data;
  }
}
